import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { logException } from "@util/errors";
import type {
  FallbackProps,
  ErrorBoundaryProps as ReactErrorBoundaryProps,
} from "react-error-boundary";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { ErrorState } from "../ui/index.js";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: ReactErrorBoundaryProps["fallbackRender"];
}

function ErrorBoundary({ children, fallback }: ErrorBoundaryProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset: resetQueryError }) => (
        <ReactErrorBoundary
          fallbackRender={fallback || ErrorFallback}
          onError={logException}
          onReset={resetQueryError}
        >
          {children}
        </ReactErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}

function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
  return <ErrorState className="py-6 md:py-20" onReload={resetErrorBoundary} />;
}

export default ErrorBoundary;
